import React, { useState, useEffect  } from 'react';
import './Marquee.css';
import traLogo from '../assets/Logo-TRA.png'; // Adjust path as needed
import tripadvisorLogo from '../assets/tripadvisor.png'; // Adjust path as needed
import AOS from "aos";
import "aos/dist/aos.css";

const Marquee = () => {

      useEffect(() => {
        window.scrollTo(0,0);
        AOS.init();
        AOS.refresh();
      }, []);

  const [isVertical, setIsVertical] = useState(false);

  const toggleDirection = () => {
    setIsVertical(!isVertical);
  };

  const logos = [traLogo, tripadvisorLogo];

  return (
    <div data-aos="zoom-in" className="marquee-page">
      <h1 className="marquee-title">Our Partners</h1>
      <button
        className={`marquee-toggle ${isVertical ? 'marquee-toggle--vertical' : ''}`}
        onClick={toggleDirection}
        aria-label="Toggle scroll direction"
      >
        <span>Toggle scroll axis</span>
        <svg aria-hidden="true" viewBox="0 0 512 512" width="100" title="arrows-alt-h">
          <path d="M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z" />
        </svg>
      </button>

      <article className={`marquee-wrapper ${isVertical ? 'marquee-wrapper--vertical' : ''}`}>
        <div className={`marquee-container ${isVertical ? 'marquee-container--vertical' : ''}`}>
          <div className="marquee-group">
            {logos.map((logo, index) => (
              <img key={`group1-${index}`} src={logo} alt="Logo" className="marquee-logo" />
            ))}
          </div>
          <div aria-hidden="true" className="marquee-group">
            {logos.map((logo, index) => (
              <img key={`group1-hidden-${index}`} src={logo} alt="Logo" className="marquee-logo" />
            ))}
          </div>
        </div>

        <div className={`marquee-container marquee-container--reverse ${isVertical ? 'marquee-container--vertical' : ''}`}>
          <div className="marquee-group">
            {logos.map((logo, index) => (
              <img key={`group2-${index}`} src={logo} alt="Logo" className="marquee-logo" />
            ))}
          </div>
          <div aria-hidden="true" className="marquee-group">
            {logos.map((logo, index) => (
              <img key={`group2-hidden-${index}`} src={logo} alt="Logo" className="marquee-logo" />
            ))}
          </div>
        </div>
      </article>
    </div>
  );
};

export default Marquee;